<template>
  <section class="theme-page" @scroll="handleScroll" ref="container">
    <div class="head">
      <img width="100%" class="banner" :src="bannerImg" @load="bannerLoad" />
      <div class="nav-wrap" ref="navBtnCon">
        <div class="nav-btn-con" :class="{'nav-fixed': fixNavTop}">
          <div class="nav">
            <div class="main-nav">
              <a
                class="nav-btn"
                v-for="(item, index) in navList"
                :key="'main' + index"
                :class="[item.sub.includes(activeId) && 'active' ]"
              >
                <img :src="mainNavBg(item)" @click="handleNavClick(item.id)" />
              </a>
            </div>
            <div class="sub-nav">
              <a
                class="sub-nav-btn"
                v-for="(item, index) in activeNav.sub_list"
                :key="'sub' + index"
                :class="[item.id === activeId && 'active' ]"
              >
                <img
                  :src="item.bg"
                  @click="handleNavClick(item.id)"
                />
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="content">
      <div class="img-con" :ref="img.id" v-for="(img,index) in pictures" :key="index" @click="handleClick(img.id)">
        <template v-if="img.src">
          <img :ref="img.ref" :src="img.src" :data-id="img.id" />
        </template>
        <template v-else>
          <img :ref="index == 0 ? img.ref : ''" v-for="(son, index) in img.son" :key="index" :src="son" :data-id="img.id" />
        </template>
      </div>
      <div class="img-con">
        <img width="100%" :src="authorityImg" />
      </div>
    </div>
  </section>
</template>
<script>
import minirouterMethod from "@/mixins/minirouterMethod.js";
import { BRAND_HIMOGOLD } from "@/util/enum/brand.js";
import THEME_IMG from "./assets/banner.jpg";
import AUTHORITY_IMG from "./assets/authority.jpg";

const ID_LIST = [...Array(13).keys()];

const NAVS_LIST = [
  {
    id: ID_LIST[0],
    brand: BRAND_HIMOGOLD,
    jump: "28415", // FORLOVE_COUPLE
    sub: [ID_LIST[0], ID_LIST[1]]
  },
  {
    id: ID_LIST[2],
    brand: BRAND_HIMOGOLD,
    jump: "28420", // FORLOVE_SINGLE
    sub: [ID_LIST[2], ID_LIST[3], ID_LIST[4]]
  },
  {
    id: ID_LIST[5],
    brand: BRAND_HIMOGOLD,
    jump: "28416", // FORLOVE_GUIMI
    sub: [ID_LIST[5], ID_LIST[6]]
  },
  {
    id: ID_LIST[7],
    brand: BRAND_HIMOGOLD,
    jump: "28417", // FORLOVE_BROTHER
    sub: [ID_LIST[7], ID_LIST[8]]
  },
  {
    id: ID_LIST[9],
    brand: BRAND_HIMOGOLD,
    jump: "28418", // FORLOVE_FAMILY
    sub: [ID_LIST[9], ID_LIST[10]]
  },
  {
    id: ID_LIST[11],
    brand: BRAND_HIMOGOLD,
    jump: "28419", // FORLOVE_PET
    sub: [ID_LIST[11], ID_LIST[12]]
  }
];

NAVS_LIST.map((nav, index) => {
  nav.bg = require(`./assets/nav/main-${index + 1}.png`);
  nav.active_bg = require(`./assets/nav/main-${index + 1}_active.png`);
  nav.sub_list = [];
  nav.sub.map((id, index) => {
    nav.sub_list.push({
      id,
      bg: require(`./assets/nav/sub-${index + 1}.png`),
      active: require(`./assets/nav/sub-${index + 1}_active.png`)
    });
  });
});

export default {
  name: "themeForLove",
  mixins: [minirouterMethod],
  data() {
    return {
      navToTop: 0,
      navOffHeight: 0,
      activeId: ID_LIST[0],
      bannerImg: THEME_IMG,
      authorityImg: AUTHORITY_IMG,
      navList: NAVS_LIST,
      pictures: [
        {
          id: ID_LIST[0],
          jump: "28415",
          son: [
            require('./assets/1-1-1.jpg'),
            require('./assets/1-1-2.jpg'),
            require('./assets/1-1-3.jpg'),
            require('./assets/1-1-4.jpg'),
          ],
          name: '情侣-暖意'
        },
        {
          id: ID_LIST[1],
          jump: "28415",
          son: [
            require('./assets/1-2-1.jpg'),
            require('./assets/1-2-2.jpg'),
            require('./assets/1-2-3.jpg'),
            require('./assets/1-2-4.jpg'),
            require('./assets/1-2-5.jpg'),
          ],
          name: '情侣-清愈 '
        },
        {
          id: ID_LIST[2],
          jump: "28420",
          son: [
            require('./assets/2-1-1.jpg'),
            require('./assets/2-1-2.png'),
            require('./assets/2-1-3.png'),
            require('./assets/2-1-4.jpg'),
          ],
          name: '单人-暖意'
        },
        {
          id: ID_LIST[3],
          jump: "28420",
          son: [
            require('./assets/2-2-1.jpg'),
            require('./assets/2-2-2.jpg'),
            require('./assets/2-2-3.jpg'),
            require('./assets/2-2-4.jpg'),
            require('./assets/2-2-5.jpg'),
          ],
          name: '单人-清愈'
        },
        {
          id: ID_LIST[4],
          jump: "28420",
          son: [
            require('./assets/2-3-1.jpg'),
            require('./assets/2-3-2.jpg'),
            require('./assets/2-3-3.jpg'),
            require('./assets/2-3-4.jpg'),
            require('./assets/2-3-5.jpg'),
            require('./assets/2-3-6.png'),
          ],
          name: '单人-我和我'
        },
        {
          id: ID_LIST[5],
          jump: "28416",
          son: [
            require('./assets/3-1-1.png'),
            require('./assets/3-1-2.jpg'),
            require('./assets/3-1-3.jpg'),
            require('./assets/3-1-4.jpg'),
          ],
          name: '闺蜜-暖意'
        },
        {
          id: ID_LIST[6],
          jump: "28416",
          son: [
            require('./assets/3-2-1.jpg'),
            require('./assets/3-2-2.jpg'),
            require('./assets/3-2-3.jpg'),
            require('./assets/3-2-4.jpg'),
            require('./assets/3-2-5.jpg'),
          ],
          name: '闺蜜-清愈'
        },
        {
          id: ID_LIST[7],
          jump: "28417",
          son: [
            require('./assets/4-1-1.jpg'),
          ],
          name: '兄弟-暖意'
        },
        {
          id: ID_LIST[8],
          jump: "28417",
          son: [
            require('./assets/4-2-1.jpg'),
          ],
          name: '兄弟-清愈'
        },
        {
          id: ID_LIST[9],
          jump: "28418",
          son: [
            require('./assets/5-1-1.png'),
            require('./assets/5-1-2.png'),
            require('./assets/5-1-3.jpg'),
            require('./assets/5-1-4.jpg'),
          ],
          name: '亲子-暖意'
        },
        {
          id: ID_LIST[10],
          jump: "28418",
          son: [
            require('./assets/5-2-1.jpg'),
            require('./assets/5-2-2.jpg'),
          ],
          name: '亲子-清愈'
        },
        {
          id: ID_LIST[11],
          jump: "28419",
          son: [
            require('./assets/6-1-1.jpg'),
            require('./assets/6-1-2.jpg'),
          ],
          name: '人宠-暖意'
        },
        {
          id: ID_LIST[12],
          jump: "28419",
          son: [
            require('./assets/6-2-1.jpg'),
            require('./assets/6-2-2.jpg'),
          ],
          name: '人宠-清愈'
        },
      ],
      fixNavTop: false
    };
  },
  computed: {
    activeNav() {
      return (
        this.navList.find(item => {
          if (
            item.id === this.activeId ||
            item.sub_list.find(sub => sub.id === this.activeId)
          ) {
            return item;
          }
        }) || {}
      );
    }
  },
  methods: {
    mainNavBg(item) {
      if (item.id === this.activeId) {
        status = true;
      }
      if (item.sub_list.some(sub => sub.id === this.activeId)) {
        status = true;
      }
      return item.bg;
    },
    async bannerLoad() {
      await this.$nextTick();
      this.navOffHeight = this.$refs.navBtnCon?.offsetHeight || 0;
      this.navToTop = this.$refs.navBtnCon?.offsetTop || 0;
    },
    // 点击切换nav
    handleNavClick(prodId) {
      this.activeId = Number(prodId);
      this.$refs["container"].scrollTop =
        this.$refs[this.activeId][0].offsetTop - this.navOffHeight;
    },
    // 监听点击事件并跳转到对应产品
    handleClick(id) {
      let { brand, jump } = this.activeNav;
      if (id === 4) jump = '28421'
      this.miniRouterLink(brand, jump);
    },
    // 监听页面滚动
    handleScroll(e) {
      this.fixNavTop = e.target.scrollTop > this.navToTop;
      let scrolledDistance = e.target.scrollTop + this.navOffHeight;
      for (let i = 0; i < ID_LIST.length; i++) {
        let { offsetTop } = this.$refs[i][0];
        if (scrolledDistance >= offsetTop - 10) {
          this.activeId = i;
        }
      }
    }
  }
};
</script>
<style lang="less" scoped>
@import "./index.less";
</style>
